import React from 'react';
import '../components-css/mini-headers.scss'

const MiniHeaders = ({headerName}) => {
    return (
        <div className={'spaces'}>
            {headerName}
        </div>
    );
};

export default MiniHeaders;
